import React, { FCC } from 'react'
import { Text } from '../Box'
import { pluralize } from '@sketch/utils'

export interface PluralizeProps {
  singular: string
  plural?: string
  count: number
  showCount?: boolean
  wrapperElement?: React.ElementType
}

export const Pluralize: FCC<PluralizeProps> = ({
  singular,
  plural,
  count,
  showCount,
  wrapperElement: WrapperElement = Text,
  ...props
}) => {
  return (
    <WrapperElement {...props}>
      {`${showCount ? count : ''} ${pluralize(singular, plural, count)}`.trim()}
    </WrapperElement>
  )
}

export { pluralize }
